// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3tehJ","error":"Textarea_error__23Wza","readonly":"Textarea_readonly__1bIrU","disabled":"Textarea_disabled__3w-O-"};